import { writable } from 'svelte/store';

export const selectPopup = writable(null);

export const popudData = writable({});